export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark'
}

export enum ColorsTypes {
  LIGHTEST = 'lightest',
  LIGHTER = 'lighter',
  LIGHT = 'light',
  NORMAL = 'normal',
  DARK = 'dark',
  DARKER = 'darker',
  DARKEST = 'darkest'
}

export enum Colors {
  BLUE = 'BLUE',
  CYAN = 'CYAN',
  GRAY = 'GRAY',
  GREEN = 'GREEN',
  PINK = 'PINK',
  PURPLE = 'PURPLE',
  ORANGE = 'ORANGE',
  YELLOW = 'YELLOW'
}

export enum FixedColorsHex {
  '#5981E3' = 'BLUE',
  '#51C1C3' = 'CYAN',
  '#191C1F' = 'GRAY',
  '#009D43' = 'GREEN',
  '#E25EB5' = 'PINK',
  '#7C5EE2' = 'PURPLE',
  '#EF4E23' = 'ORANGE',
  '#EFBA0F' = 'YELLOW'
}
